export default __webpack_public_path__ + "locales/fr/People.json?hash=625fd6634394ff6bbdfe1d3db8ea7b47";